import { cn } from '@/utils'
import { PagePreview } from './PagePreview'
import { PENDING_DIM } from './PendingNote'
import type { DocumentPage } from './types'

interface PageReaderProps {
  page: DocumentPage | null
  statementPages: DocumentPage[]
  filedUnder: string | null
  stripMoving: boolean
}

// The reader is about the page you clicked, which stays true while pages are held.
export const PageReader = ({
  page,
  statementPages,
  filedUnder,
  stripMoving,
}: PageReaderProps) => (
  <div className={cn(stripMoving && PENDING_DIM)}>
    {page ? (
      <PagePreview
        page={page}
        statementPages={statementPages}
        filedUnder={filedUnder}
      />
    ) : (
      <p data-page-reader className="p-4 text-sm text-ink-subtle">
        Click a page to read it here.
      </p>
    )}
  </div>
)
